export enum RequestStatus{
    reject = "reject",
    accept = "accept",
}

export enum ConnectionType{
    friend = "friend",
    following = "following",
    friendRequest = "friendrequest",
    friendRequestAccepted = "friendrequestaccepted",
}